import React from 'react';

import { myPiggyIcons } from '../../assets/icons/mypiggy';

export const MY_PIGGY_ICON_SIZES = Object.freeze({
  xs: 24,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 96,
  hero: 128,
});

const MyPiggyIcon = ({
  name,
  size = 'md',
  alt,
  decorative = true,
  className = '',
  loading = 'lazy',
}) => {
  const icon = myPiggyIcons[name];

  if (!icon) {
    if (import.meta.env.DEV) {
      console.warn(`Unknown MyPiggy icon: ${name}`);
    }

    return null;
  }

  const pixelSize = MY_PIGGY_ICON_SIZES[size] || size;

  return (
    <img
      src={icon.src}
      alt={decorative ? '' : (alt || icon.alt)}
      aria-hidden={decorative ? 'true' : undefined}
      width={pixelSize}
      height={pixelSize}
      loading={loading}
      decoding="async"
      className={`inline-block shrink-0 object-contain ${className}`.trim()}
    />
  );
};

export default MyPiggyIcon;

